module.exports = __webpack_public_path__ + "img/dashboard.fb89736f.svg";